import { createSelector } from 'reselect';

import { ACTION_TYPE_ALERT, ALERT_TYPE_KEY } from 'constants/rules';

import { selectUnderwriting } from './underwriting.selectors';

export const selectRuleActions = createSelector(
  selectUnderwriting,
  ({ ruleActions }) => Object.values(ruleActions) || [],
);

export const selectRuleActionsSeverityOptions = createSelector(selectRuleActions, actions => {
  const actionType = actions.find(action => action.type === ACTION_TYPE_ALERT)?.args;
  const actionArguments = actionType?.find(alert => alert.key === ALERT_TYPE_KEY)?.value;

  return actionArguments?.map(alertType => ({ value: alertType }));
});
